const menuButton = document.getElementById("menuButton");
const menuContactWrap = document.getElementById("js-menu_layer"); // menu_contact_wrapを取得
let isMenuOpened = false;

// 初期状態のaria-expandedを設定
if (menuButton) {
  menuButton.setAttribute("aria-expanded", "false");
}

function toggleMenu() {
  isMenuOpened = !isMenuOpened;
  if (isMenuOpened) {
    // メニューを開いた時の処理
    menuButton.classList.add("is-opened");
    menuContactWrap.classList.add("is-opened"); // menu_contact_wrapにクラスを追加
    // アクセシビリティ: メニュー開状態を通知
    menuButton.setAttribute("aria-expanded", "true");
  } else {
    // メニューを閉じた時の処理
    menuButton.classList.remove("is-opened");
    menuContactWrap.classList.remove("is-opened"); // menu_contact_wrapのクラスを削除
    // アクセシビリティ: メニュー閉状態を通知
    menuButton.setAttribute("aria-expanded", "false");
  }
}

menuButton.addEventListener("click", toggleMenu);
